// extracted by mini-css-extract-plugin
export default {"phone-verification-container":"styles__phone-verification-container--K+rJ2"};